import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { TopNudgeVO } from '@domain/vo/NudgeVO';
import { EXTENDED_TOP_NUDGE_HEIGHT, TOP_NUDGE_HEIGHT } from '@domain/constant/layout';
import { Position, useScrollPos } from '@utils/hooks/useScroll';
import useOnMount from '@utils/hooks/useOnMount';
import classnames from 'classnames/bind';
import styles from './topNudge.module.scss';

const cx = classnames.bind(styles);

const headerScrollUpdateController = (pos: Position) => {
  // event 넛지 펼쳤을 때 320이어서 이 범위를 넘어가는 범위에서는 scroll 이벤트 listen 불필요
  // 하지만 약간의 offset을 둬서 500까지 scroll 이벤트 listen
  if (pos.top > 500) return false;
  return true;
};

let prevExtended = false;

interface Props {
  topNudges: Map<string, TopNudgeVO>;
}

const TopNudge = ({ topNudges }: Props) => {
  const [isTopNudgeExtended, setIsTopNudgeExtended] = useState(false);

  const getTopNudgeByPath = (path: string) => {
    if (topNudges.has(path)) return topNudges.get(path);
    if (topNudges.has('global')) return topNudges.get('global');
    return null;
  };

  const { asPath: pathname } = useRouter();
  const [topNudge, setTopNudge] = useState<TopNudgeVO | null>(null);

  const btnExtendClick = () => {
    setIsTopNudgeExtended((prev) => !prev);
  };

  const position = useScrollPos(undefined, headerScrollUpdateController);
  useEffect(() => {
    const isExtendedChanged = prevExtended !== isTopNudgeExtended;
    // if (isTopNudgeExtended && position.top > EXTENDED_TOP_NUDGE_HEIGHT) {
    // 	changeIsTopNudgeOpened(false);
    // } else
    if (isExtendedChanged) {
      const isTopNudgeClosedInViewport =
        !isTopNudgeExtended && position.top > TOP_NUDGE_HEIGHT && position.top <= EXTENDED_TOP_NUDGE_HEIGHT;

      if (isTopNudgeClosedInViewport) {
        document.documentElement.scrollTop = 0;
      }
    }

    return () => {
      prevExtended = isTopNudgeExtended;
    };
  }, [position, isTopNudgeExtended]);

  useOnMount(() => {
    setIsTopNudgeExtended(false);
  });

  useEffect(() => {
    setTopNudge(getTopNudgeByPath(pathname) ?? null);
  }, [topNudges.size, pathname]); // Map만 dependency로 두면 rerender안됨,,

  if (topNudge === null) return null;

  const { link, previewImageImgPath, thumbnailImageImgPath, backgroundColor } = topNudge;
  const imgPath = isTopNudgeExtended ? thumbnailImageImgPath : previewImageImgPath;
  const btnClassName = isTopNudgeExtended ? 'btnClose' : 'btnExtend';

  return (
    <div className={cx('eventArea', { extend: isTopNudgeExtended })} style={{ background: `${backgroundColor}` }}>
      <a href={link} className={cx('link')} style={{ backgroundImage: `url(${imgPath})` }} />
      <a className={cx(btnClassName)} onClick={btnExtendClick} role="button" />
    </div>
  );
};

export default TopNudge;
